// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__jXXwo","content":"page_content__tyfWn"};